import HeroBanner from "../../components/HeroBanner";
// import SkillSection from "../../components/SkillSection";
import ContactSection from "../../components/ContactSection";
import "./HomePage.scss";

import { useEffect, useState } from "react";
import Loader from "../../components/Loader/Loader";
import Footer from "../../components/Footer";
import Header from "../../components/Header";
import ProjectSection from "../../components/ProjectSection";

// import HomeHeader from "../../components/HomeHeader";
// import HeroBanner from "../../components/HeroBanner";
// import CardSection from "../../components/CardSection";
// import Footer from "../../components/Footer";

export default function HomePage() {
  const [loader, setLoader] = useState(true);

  useEffect(() => {
    const loadTime = window.innerWidth < 696 ? 2500 : 4000;
    // const loadTime = 0;
    setTimeout(() => setLoader(false), loadTime);
  }, []);

  return (
    <>
      {loader && <Loader />}
      <div
        className="homepage"
        onScroll={() => {
          console.log("hi");
        }}
      >
        {/* <div className={`homepage ${loader ? "" : "homepage--active"}`}> */}
        {!loader && (
          <>
            <Header />
            <HeroBanner />
            <ProjectSection />
            {/* <SkillSection /> */}
            <ContactSection />
            <Footer />
          </>
        )}
      </div>
    </>
  );
}

// import React from "react";

// export default class HomePage extends React.Component {
//   state = {
//     loader: true,
//   };

//   componentDidMount() {
//     const loadTime = window.innerWidth < 696 ? 2500 : 4000;
//     // const loadTime = 0;
//     setTimeout(() => {
//       this.setState({ loader: false });
//     }, loadTime);
//   }
//   handleScroll = (e) => {
//     let element = e.target;
//     console.log("hello");
//     if (element.scrollHeight - element.scrollTop === element.clientHeight) {
//       // do something at end of scroll
//     }
//   };
//   render() {
//     const { loader } = this.state;
//     return (
//       <>
//         <div className="content-container" onScroll={this.handleScroll}>
//           Hello
//           {loader && <Loader />}
//           <div
//             className="homepage"
//             onScroll={() => {
//               console.log("hi");
//             }}
//           >
//             {/* <div className={`homepage ${loader ? "" : "homepage--active"}`}> */}
//             {!loader && (
//               <>
//                 <Header />
//                 <HeroBanner />
//                 <SkillSection />
//                 <ContactSection />
//                 <Footer />
//               </>
//             )}
//           </div>
//         </div>
//       </>
//     );
//   }
// }
